export default __webpack_public_path__ + "static/media/browsingassessments.a93362fd.svg";